module.exports = __webpack_public_path__ + "img/VIDEO_THUMBNAIL.8bdad84d.svg";